import React from "react";
import "./LiveStream.scss";

type SportStatProps = {
  eventID: string;
};

const LiveStream: React.FC<SportStatProps> = (props) => {
  const { eventID } = props;

  return (
    <div className="cricket-live-stream-ctn">
      <iframe
        className="mob-live-stream"
        allowFullScreen={false}
        src={`https://vid.dreamcasino.live/GetAPI.html?MatchID=${eventID}`}
        sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
        width="100%"
      ></iframe>
    </div>
  );
};

export default LiveStream;
